import { SubscriptionPlan, User } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";
import { isYearlySubscription } from "@/utils/subscriptionLevels/isYearlySubscription";

// Canonical PostHog subscription bag: $set as person properties (current state) and spread into event properties (point-in-time).
export const getSubscriptionProperties = (
  stripeSubscriptionId: User["stripeSubscriptionId"]
): {
  subscriptionPlan: SubscriptionPlan;
  billingInterval: "month" | "year" | null;
} => {
  const subscriptionPlan = getSubscriptionPlan(stripeSubscriptionId);

  // Unknown price ids map to "free", so they get no billing interval either
  if (stripeSubscriptionId === null || subscriptionPlan === "free") {
    return {
      subscriptionPlan: subscriptionPlan,
      billingInterval: null,
    };
  }

  return {
    subscriptionPlan: subscriptionPlan,
    billingInterval:
      isYearlySubscription(stripeSubscriptionId) ? "year" : "month",
  };
};
